import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../../components/feature/SEOHead';
import ExercicioGratisNavbar from '../components/ExercicioGratisNavbar';
import LeadCaptureForm from '../components/LeadCaptureForm';

export default function ModelagemExcelenciaGratis() {
  const [areaSelecionada, setAreaSelecionada] = useState('');
  const [modeloReferencia, setModeloReferencia] = useState('');
  const [showLimit, setShowLimit] = useState(false);

  const areasVida = [
    { nome: 'Carreira', emoji: '💼', cor: 'from-blue-500 to-blue-600' },
    { nome: 'Relacionamentos', emoji: '❤️', cor: 'from-pink-500 to-pink-600' },
    { nome: 'Saúde', emoji: '🏃', cor: 'from-green-500 to-green-600' },
    { nome: 'Finanças', emoji: '💰', cor: 'from-yellow-500 to-yellow-600' },
    { nome: 'Liderança', emoji: '👑', cor: 'from-purple-500 to-purple-600' },
    { nome: 'Comunicação', emoji: '🎤', cor: 'from-orange-500 to-orange-600' },
    { nome: 'Criatividade', emoji: '🎨', cor: 'from-indigo-500 to-indigo-600' },
    { nome: 'Espiritualidade', emoji: '🙏', cor: 'from-teal-500 to-teal-600' },
  ];

  const handleContinuar = () => {
    if (!areaSelecionada || !modeloReferencia) return;
    setShowLimit(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 via-white to-purple-50">
      <SEOHead
        title="Modelagem de Excelência PNL Grátis | Replicar Sucesso — Carta do Eu Futuro"
        description="Experimente gratuitamente a Modelagem de Excelência de PNL. Aprenda a identificar e replicar padrões de sucesso de pessoas que já alcançaram o que você deseja."
        keywords="modelagem de excelência, PNL grátis, replicar sucesso, programação neurolinguística"
        canonical="/exercicio-gratis/modelagem-excelencia-pnl"
      />
      <ExercicioGratisNavbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 px-6 bg-gradient-to-br from-charcoal-950 via-charcoal-900 to-charcoal-950 text-white overflow-hidden">
        <div className="max-w-4xl mx-auto relative z-10">
          <div className="inline-block px-4 py-2 bg-gold-500/15 border border-gold-500/30 text-gold-400 rounded-full text-sm font-semibold mb-6 font-['Montserrat']">VERSÃO GRATUITA</div>
          <h1 className="font-['Playfair_Display'] text-5xl font-bold mb-6 leading-tight text-white">Modelagem de Excelência — PNL</h1>
          <p className="text-xl text-white/70 mb-8 leading-relaxed font-['Montserrat'] font-light">Aprenda a replicar padrões de sucesso de pessoas que já alcançaram o que você deseja.</p>
        </div>
      </section>

      {/* O que é */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">O que é Modelagem de Excelência?</h2>
          <p className="text-lg text-slate-700 leading-relaxed mb-6">Modelagem é o processo de <strong>identificar e replicar</strong> os padrões mentais, comportamentais e emocionais de pessoas que alcançaram excelência em determinada área.</p>
          <div className="bg-gradient-to-r from-violet-50 to-purple-50 rounded-2xl p-6 border-2 border-violet-200">
            <p className="text-lg text-violet-900 font-semibold">&quot;Se alguém pode fazer algo, qualquer pessoa pode aprender a fazê-lo também&quot; — Richard Bandler (criador da PNL)</p>
          </div>
        </div>
      </section>

      {/* Passos */}
      <section className="py-16 px-6 bg-slate-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-slate-900 mb-8">Passos da Modelagem</h2>
          <div className="space-y-6">
            {/* Passo 1 */}
            <div className="bg-white rounded-2xl p-8 border border-slate-200">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center text-white font-bold text-xl flex-shrink-0">1</div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-slate-900 mb-3">Escolha a área de vida</h3>
                  <p className="text-slate-700 mb-4">Selecione em qual área você deseja alcançar excelência</p>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    {areasVida.map((area) => (
                      <button key={area.nome} onClick={() => setAreaSelecionada(area.nome)} className={`p-3 rounded-xl border-2 transition-all cursor-pointer ${areaSelecionada === area.nome ? `bg-gradient-to-br ${area.cor} text-white border-transparent scale-105` : 'bg-white border-slate-200 hover:border-violet-300'}`}>
                        <div className="text-2xl mb-1">{area.emoji}</div>
                        <div className={`text-xs font-semibold ${areaSelecionada === area.nome ? 'text-white' : 'text-slate-700'}`}>{area.nome}</div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* Passo 2 */}
            <div className="bg-white rounded-2xl p-8 border border-slate-200">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center text-white font-bold text-xl flex-shrink-0">2</div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-slate-900 mb-3">Identifique seu modelo de referência</h3>
                  <textarea value={modeloReferencia} onChange={(e) => setModeloReferencia(e.target.value)} maxLength={200} placeholder="Ex: Tony Robbins (comunicação), meu chefe João (gestão de equipes)..." className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:border-violet-500 focus:ring-2 focus:ring-violet-200 outline-none transition-all resize-none" rows={3} />
                  <div className="text-xs text-slate-500 mt-1">{modeloReferencia.length}/200 caracteres</div>
                </div>
              </div>
            </div>
            {/* Bloqueados */}
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/80 to-white z-10 flex items-center justify-center backdrop-blur-sm rounded-2xl">
                <div className="text-center p-8">
                  <div className="w-16 h-16 rounded-full bg-charcoal-100 flex items-center justify-center mx-auto mb-4"><i className="ri-lock-fill text-3xl text-charcoal-400"></i></div>
                  <h3 className="font-['Playfair_Display'] text-2xl font-bold text-charcoal-800 mb-2">Mais 5 passos na versão completa</h3>
                  <p className="text-charcoal-500 mb-6 font-['Montserrat']">Crenças, estratégias mentais, plano de replicação e muito mais</p>
                  <Link to="/planos#exercicios-pnl" className="inline-block px-8 py-3 bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 rounded-full font-semibold transition-all whitespace-nowrap font-['Montserrat']">Ver Versão Completa</Link>
                </div>
              </div>
              <div className="blur-sm pointer-events-none space-y-6">
                {[3,4,5,6,7].map((n) => <div key={n} className="bg-white rounded-2xl p-8 border border-slate-200"><div className="flex items-start gap-4"><div className="w-12 h-12 rounded-full bg-slate-300 flex items-center justify-center text-white font-bold text-xl flex-shrink-0">{n}</div><div><h3 className="text-xl font-bold text-slate-900 mb-2">Passo {n}</h3><p className="text-slate-700">Disponível na versão completa...</p></div></div></div>)}
              </div>
            </div>
          </div>
          <div className="mt-8 space-y-4">
            <button onClick={handleContinuar} className="w-full py-4 bg-gradient-to-r from-violet-600 to-purple-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">Continuar para Próximo Passo</button>
            {showLimit && (
              <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-6 text-center">
                <h3 className="text-xl font-bold text-red-900 mb-2">Limite da Versão Gratuita Atingido</h3>
                <p className="text-red-700 mb-4">Para acessar os passos completos, adquira a versão completa</p>
                <Link to="/planos#exercicios-pnl" className="inline-block px-8 py-4 bg-gradient-to-r from-violet-600 to-purple-600 text-white rounded-xl font-semibold transition-all whitespace-nowrap">Comprar Versão Completa — R$ 18</Link>
              </div>
            )}
          </div>
        </div>
      </section>

      <LeadCaptureForm exercicioNome="Modelagem de Excelência (PNL)" />

      {/* CTA Final */}
      <section className="py-16 px-6 bg-gradient-to-br from-charcoal-950 via-charcoal-900 to-charcoal-950 text-white">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-12 h-px bg-gold-500/30 mx-auto mb-8"></div>
          <h2 className="font-['Playfair_Display'] text-4xl font-bold mb-6 text-white">Pronto para replicar padrões de excelência?</h2>
          <p className="text-xl text-white/55 mb-8 font-['Montserrat'] font-light">Acesse a versão completa da Modelagem de Excelência e decodifique estratégias de sucesso comprovadas.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/planos#exercicios-pnl" className="px-10 py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 rounded-full font-bold text-sm hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] tracking-wide">Comprar por R$ 18</Link>
            <Link to="/planos#exercicios-pnl" className="px-10 py-4 bg-white/8 text-white rounded-full font-bold text-sm hover:bg-white/15 transition-all whitespace-nowrap border border-gold-500/20 font-['Montserrat'] tracking-wide">Pacote 6 Técnicas - R$ 47</Link>
          </div>
          <p className="text-sm text-white/30 mt-6 font-['Montserrat']">Acesso vitalício · Auto-save · Sistema de conquistas</p>
        </div>
      </section>
    </div>
  );
}
